<div class="file-library">
    <header class="page-header">
        <div class="row">
            <div class="col-md-4">
                <h2 class="title pull-left">FILES</h2>
            </div>
            <div class="col-sm-8 text-end">
                <div class="controls">
                    <button *ngIf="!isDirectoryEmpty((directoryInfo$ | async))" class="btn btn-toggle btn-toggle-no-shadow" [ngClass]="{'selected': showFilter}" (click)="onToggleFilter()">
                        <i class="fa fa-filter" aria-hidden="true"></i> Filters
                    </button>
                </div>
            </div>
        </div>
        <sp-component-filter
            [propertyId]="selectedPropertyId"
            [filterSettings]="filterSettings"
            [showCategoriesFilter]="false"
            [filterTitle]="'Filter Files'"
            [filterPlaceholderText]="'File Name / ' + (('component' | terminology | async) || 'component') + ' Name'"
            [saveFilterSettingsOnChange]="false"
            [hidden]="!showFilter"
            (hideFilter)="onHideFilter()"
            (filterSettingsChanged)="onSearchFiles($event)"
            #filterComponent>
        </sp-component-filter>
    </header>


    <div class="menu-container">
        <div class="row">
            <div class="col-md-6">
                <div class="folder-breadcrumb" *ngIf="!hasSeachFilters()">
                    <ng-container [ngTemplateOutlet]='folderBreadcrumbTemplate' [ngTemplateOutletContext]="{folder: (directoryInfo$ | async)}"></ng-container>
                </div>
                <div *ngIf="hasSeachFilters()">
                    <strong>Search Results</strong>
                </div>
            </div>
            <div class="col-md-6 text-end">
                <ng-container *ngIf="!hasSeachFilters()">
                    <button class="btn btn-link btn-add-folder" (click)="showAddFolderModal()">
                        <span class="fa-stack ">
                            <i class="fa-regular fa-folder fa-stack-2x"></i>
                            <i class="fa fa-plus fa-stack-1x"></i>
                        </span> Create Folder
                    </button>

                    <button class="btn btn-link btn-add-files" (click)="showUploadFileModal()">
                        <span class="fa-stack ">
                            <i class="fa-regular fa-file fa-stack-2x"></i>
                            <i class="fa fa-plus fa-stack-1x"></i>
                        </span> Add Files
                    </button>
                </ng-container>
            </div>
        </div>
    </div>


    <div class="file-list">
        <sp-file-list-display [directoryInfo]="(directoryInfo$ | async)" [folderStructure]="(folderStructure$ | async)"
            [propertyId]="selectedPropertyId" [fiscalYear]="selectedFiscalYear"
            (folderSelected)="onFolderSelected($event)"
            (folderRenamed)="onFolderRenamed($event)"
            (folderMoved)="onFolderMoved($event)"
            (folderDeleted)="onFolderDeleted($event)"
            (fileRenamed)="onFileRenamed($event)"
            (fileMoved)="onFileMoved($event)"
            (fileDeleted)="onFileDeleted($event)"
            (downloadFile)="onDownloadFile($event)"
            (assignComponents)="onAssignComponents($event)"
            (moveBulk)="onMoveBulk($event)"
            (downloadBulk)="onDownloadBulk($event)"
            (deleteBulk)="onDeleteBulk($event)"
            >
        </sp-file-list-display>
    </div>

    <div *ngIf="isDirectoryEmpty((directoryInfo$ | async))" class="empty-folder-message">
        <div class="icon-container">
            <i class="fa-regular fa-folder-open fa-3x"></i>
        </div>
        <div *ngIf="!hasSeachFilters()">
            <h3 class="margin-top-25">No files have been added {{selectedFolderId == null ? 'for your property' : 'to this folder'}}!</h3>
            <button class="btn btn-success" (click)="showUploadFileModal()">
                Upload Files
            </button>
            <button class="btn btn-success" (click)="showAddFolderModal()">
                Create Folder
            </button>
        </div>
        <div *ngIf="hasSeachFilters()">
            <h3 class="margin-top-25">No results found.</h3>
            <div>Try adjusting your search to find what you're looking for.</div>
        </div>
    </div>

</div>

<sp-modal title="ERROR" cancelButtonText="Ok" isAlert="true" isWarning="true" #errorModal>
    {{errorMsg}}
</sp-modal>

<sp-add-files-modal
    #addFiles
    [propertyId]="selectedPropertyId"
    [folderId]="selectedFolderId"
    [projectId]="(directoryInfo$ | async)?.projectId"
    (onClose)="onUploadFilesComplete($event)"
></sp-add-files-modal>

<sp-modal title="CREATE FOLDER" (confirm)="onCreateFolder()" confirmButtonText="Create" #createFolder>
    <div class="row">
        <div class="col-md-6">
            <input type="text" class="form-control" [(ngModel)]="createFolderName" placeholder="Folder Name" />
        </div>
    </div>
</sp-modal>

<ng-template #folderBreadcrumbTemplate let-folder="folder"  >
    <div *ngIf="folder == null || folder.folderId == null" (click)="onFolderSelected(null)"  class="folder" [class.active-folder]="selectedFolderId == null">
        Files
    </div>

    <ng-container *ngIf="folder != null && folder.folderId != null">
        <ng-container [ngTemplateOutlet]='folderBreadcrumbTemplate' [ngTemplateOutletContext]="{folder:folder.parentFolder}"></ng-container>
        <i class="fa fa-chevron-right"></i>
        <div class="folder" (click)="onFolderSelected(folder.folderId)" [class.active-folder]="selectedFolderId == folder.folderId">
            <i class="fa fa-folder"></i>{{folder.folderName}}
        </div>
    </ng-container>
</ng-template>



